import { ShieldCheck, Truck, RotateCcw, Gem } from "lucide-react";

const ITEMS = [
  { icon: ShieldCheck, text: "Independently certified" },
  { icon: Truck, text: "Insured global shipping" },
  { icon: RotateCcw, text: "30-day returns" },
  { icon: Gem, text: "Lifetime guarantee" },
];

export function TrustStrip() {
  return (
    <div className="border-b border-hairline bg-secondary/40">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <ul className="flex flex-wrap items-center justify-center gap-x-10 gap-y-2 py-3 text-[10px] uppercase tracking-luxe text-muted-foreground">
          {ITEMS.map((item) => (
            <li key={item.text} className="flex items-center gap-2">
              <item.icon className="h-3 w-3" strokeWidth={1.25} />
              <span>{item.text}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
